import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { ModalConfig } from '@core/model/modal-config.model'

export interface ChangeRequestRebaseModalConfig {
  confirmCallback?: Function
  cancelCallback?: Function
}

@Component({
  selector: 'change-request-rebase-modal',
  templateUrl: './change-request-rebase-modal.component.html',
  styleUrls: ['./change-request-rebase-modal.component.scss'],
})
export class ChangeRequestRebaseModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ModalConfig) {}

  confirm() {
    if (this.data.confirmCallback) this.data.confirmCallback()
  }

  cancel() {
    if (this.data.cancelCallback) this.data.cancelCallback()
  }
}
